import { Stack, Text, ThemeOverride, PrimaryButton } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { Card, Avatar } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useAuth } from "@certn/auth";
import { parseName } from "@certn/utils";
import { darkColors, lightColors } from "@certn/cascadia-tokens";

export function ButtonPreview() {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <Stack orientation="vertical" gap="space-5" className={styles.container}>
      <Text style="global/heading-medium">{t("Sample")}</Text>
      <Stack orientation="vertical" gap="space-5">
        <Text style="global/heading-medium" className={styles.heading}>
          {t("Light mode")}
        </Text>
        <ThemeOverride theme="light">
          <Card className={styles.lightMode}>
            <Stack orientation="vertical" gap="space-4" className={styles.mode}>
              <Stack orientation="horizontal" gap="space-3" justify="end">
                <PrimaryButton variant="brand-primary" size="medium">
                  {t("New order")}
                </PrimaryButton>
                <Avatar name={parseName(user?.name)} size="medium" />
              </Stack>
            </Stack>
          </Card>
        </ThemeOverride>
      </Stack>
      <Stack orientation="vertical" gap="space-5">
        <Text style="global/heading-medium" className={styles.heading}>
          {t("Dark mode")}
        </Text>
        <ThemeOverride theme="dark">
          <Card className={styles.darkMode}>
            <Stack orientation="vertical" gap="space-4" className={styles.mode}>
              <Stack orientation="horizontal" gap="space-3" justify="end">
                <PrimaryButton variant="brand-primary" size="medium">
                  {t("New order")}
                </PrimaryButton>
                <Avatar name={parseName(user?.name)} size="medium" />
              </Stack>
            </Stack>
          </Card>
        </ThemeOverride>
      </Stack>
    </Stack>
  );
}

const styles = {
  container: css({
    paddingBottom: "var(--space-5)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
  }),
  mode: css({
    paddingTop: "var(--space-4)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-8)",
    paddingRight: "var(--space-8)",
  }),
  darkMode: css({
    backgroundColor: `${darkColors["surface-base"]} !important`,
  }),
  lightMode: css({
    backgroundColor: `${lightColors["surface-base"]} !important`,
  }),
  heading: css({
    paddingLeft: "var(--space-7)",
    paddingRight: "var(--space-7)",
  }),
};
